<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title
          justify-center
          class="justify-center headline purple--text title font-weight-bold"
        >{{$t('Login')}}</v-card-title>
        <v-form ref="form" v-model="valid">
          <v-card-text>
            <v-text-field
              box
              color="purple"
              v-model="email"
              v-validate="'required|email'"
              :error-messages="errors.collect('email')"
              :label="$t('E-mail')"
              name="email"
              data-vv-name="email"
              :placeholder="$t('Enter your email')"
              required
            ></v-text-field>
            <v-text-field
              box
              class="custom-append"
              color="purple"
              ref="password"
              name="password"
              :label="$t('Password')"
              data-vv-name="password"
              data-vv-delay="300"
              min="8"
              v-validate="'required|min:8'"
              v-model="password"
              :error-messages="errors.collect('password')"
              :type="isPasswordVisible ? 'text' : 'password'"
              :placeholder="$t('Enter your password')"
            >
              <template slot="append">
                <div @click="changeVal('isPasswordVisible')">
                  <span v-if="!isPasswordVisible">{{$t('Show')}}</span>
                  <span v-else>{{$t('Hide')}}</span>
                </div>
              </template>
            </v-text-field>
            <p class="text-xs-right font-weight-bold forgot-pass">
              <a
                class="purple--text"
                href="#"
                @click.prevent="openForgotPassDialog"
              >{{$t('Forgot password?')}}</a>
            </p>
          </v-card-text>
          <v-card-actions>
            <v-layout align-center justify-center column>
              <v-flex>
                <v-btn dark color="purple" @click="submit">{{$t('login')}}</v-btn>
              </v-flex>
              <v-flex>
                <v-btn @click="auth0" outline color="purple">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="3059.924 1979 16.08 16" id="google_logo">
                    <path
                      d="M3069.04,2012.4v3.2h4.549a4.82,4.82,0,1,1-4.549-6.4,4.768,4.768,0,0,1,3.124,1.158l2.113-2.413a7.981,7.981,0,1,0,2.8,6.054v-1.6Z"
                      transform="translate(-1.076 -27)"
                    ></path>
                  </svg>{{$t('SIGN IN WITH GOOGLE')}}
                </v-btn>
              </v-flex>
              <v-flex class="text-xs-center font-weight-bold">{{$t('Don’t have an account?')}}
                <router-link to="/home" class="purple--text">{{$t('Sign up')}}</router-link>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialog" max-width="350">
      <v-card>
        <v-card-title class="text-xs-center justify-center">{{$t(errorMsg)}}</v-card-title>
      </v-card>
    </v-dialog>
    <v-dialog v-model="forgotPassDialog" persistent max-width="500">
      <v-card>
        <v-card-title
          justify-center
          class="justify-center headline purple--text title font-weight-bold"
        >{{$t('Add your current email')}}</v-card-title>
        <v-card-text>
          <v-form data-vv-scope="changeMail">
            <v-text-field
              box
              color="purple"
              v-validate="'required|email'"
              v-model="email"
              :error-messages="errors.collect('email')"
              :label="$t('E-mail')"
              name="email"
              data-vv-name="email"
              :placeholder="$t('Enter your email')"
              required
            ></v-text-field>
            <v-card-actions>
              <v-layout align-center justify-center column>
                <v-flex>
                  <v-btn
                    outline
                    color="purple"
                    @click="dialog = true; forgotPassDialog = false"
                  >{{$t('cancel')}}</v-btn>
                </v-flex>
                <v-flex>
                  <v-btn dark color="purple" @click="submitEmail">{{$t('ok')}}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="success" persistent max-width="500">
      <v-card>
        <v-card-title
          justify-center
          class="justify-center headline purple--text title font-weight-bold"
        >{{$t('Done')}}</v-card-title>
        <v-card-text class="text-xs-center">{{$t('To change your password please check your email')}}</v-card-text>
        <v-card-actions class="justify-center">
          <v-btn dark color="purple" @click="dialog = true; success = false">{{$t('back to login')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
// import GAuth from 'vue-google-oauth2';
// import AuthenticationClient from "auth0/src";
// import { ErrorBag } from "vee-validate";
// import { Validator } from "vee-validate";
import axios from "axios";

Vue.use(VeeValidate);
// Vue.use(GAuth, {
//   clientId: '450656536006-oo9eijqb96gilmafd3incd5a2t8hqjbn.apps.googleusercontent.com',
//   scope: 'profile email https://www.googleapis.com/auth/plus.login'
// });
export default {
  data: () => ({
    dialog: true,
    forgotPassDialog: false,
    success: false,
    valid: true,
    email: "",
    password: "",
    isPasswordVisible: false,
    errorDialog: false,
    errorMsg: "IDK why do u see this window",
    dictionary: {
      custom: {
        email: {
          required: () => Vue.i18n.translate("Email can not be empty"),
          email: Vue.i18n.translate("Invalid email")
        },
        password: {
          required: () => Vue.i18n.translate("Password can not be empty"),
          min: Vue.i18n.translate("The password field may not be lesser than {amount} characters", {amount: 8})
        }
      }
    }
  }),

  mounted() {
    localStorage.setItem("currentLang", "en")
    Vue.i18n.set("en")
    this.$validator.localize("uk", this.dictionary);
  },

  methods: {
    submit() {
      console.log(this.$validator);
      this.$validator
        .validateAll()
        .then(result => {
          if (result) {
            axios
              .post(this.$hostname + "/client/login", {
                email: this.email,
                password: this.password
              })
              .then(response => {
                console.log(response);
                if (response.status === 200) {
                  localStorage.setItem("token", response.data.data.token);
                  this.$router.push("/profile");
                }
                // console.log(response);
                // if(response.data.detail === 101){
                //     let error = response.data.errors;
                //     if (error.invalid_data) {
                //         this.errorDialog = true,
                //         this.errorMsg = 'Wrong Email/Password'
                //     }
                // }else{
                //   localStorage.setItem('token', response.data.data.token);
                //   // console.log(response.data.data.token)
                //   this.$router.push('/profile')
                // }
              })
              .catch(error => {
                console.log(error);
                this.errorDialog = true;
                this.errorMsg = `${this.$t(this.$store.getters.errorsList[error.response.data.message])}`;
              });
          }
        })
        .catch(error => console.log(error));
    },
    auth0() {
      Vue.googleAuth().signIn(
        authorizationCode => {
          axios
            .post(this.$hostname + "/client/google/login", {
              code: authorizationCode,
              redirect_uri: this.$googleLink // http://localhost:8080
            })
            .then(response => {
              localStorage.setItem("token", response.data.data.token);
              this.$router.push("/profile");
            })
            .catch(error => {
              this.errorDialog = true;
              this.errorMsg = `${this.$t(this.$store.getters.errorsList[error.response.data.message])}`;
            });
        },
        error => {
          console.log(error);
        }
      );
    },
    changeVal(value) {
      this[value] = !this[value];
    },
    openForgotPassDialog() {
      this.dialog = false;
      this.forgotPassDialog = true;
    },
    submitEmail() {
      axios
        .post(this.$hostname + "/reset", {
          email: this.email
        })
        .then(response => {
          console.log(response);
          (this.forgotPassDialog = false), (this.success = true);
        })
        .catch(error => {
          this.errorDialog = true;
          this.errorMsg = `${this.$t(this.$store.getters.errorsList[error.response.data.message])}`;
        });
    },
    googleAuth() {
      console.log("googleAuth");
      axios
        .get("https://web.purepurr.tech/api/google/login")
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          this.errorDialog = true;
          this.errorMsg = `${this.$t(this.$store.getters.errorsList[error.response.data.message])}`;
        });
    }
  }
};
</script>
<style scoped lang="scss">
.forgot-pass {
  margin-bottom: 0;
  a {
    text-decoration: none;
    transition: all 0.3s;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>